import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import AutocompleteSelect, {
  statusRenderOption,
  statusStartAdornment
} from 'UI/components/molecules/AutocompleteSelect';
import { Endpoints } from 'UI/constants/endpoints';
import { SendoutsTypes } from 'UI/constants/status';
import { idOptionSelected, REQUIRED_VALIDATION } from 'UI/utils';

import { FORM_FIELDS_MAP } from './SendoverDetailsEditForm.constants';

const DEFAULT_STATUS_OPTIONS_URL = `${Endpoints.SendoutsStatus}?type=${SendoutsTypes.Sendover}`;

const HiddenField = () => null;

export const SendoverDetailsEditForm = ({
  onStatusSelected = () => {},
  statusOptionsUrl = DEFAULT_STATUS_OPTIONS_URL
}) => {
  const { control, errors, watch } = useFormContext();

  const currentStatus = watch(FORM_FIELDS_MAP.Status.key);

  const handleStatusChange = useCallback(
    ([, value]) => {
      const nextValue = onStatusSelected(value);
      return nextValue === undefined ? value : nextValue;
    },
    [onStatusSelected]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.Status.key}
          control={control}
          rules={REQUIRED_VALIDATION}
          defaultValue={null}
          as={
            <AutocompleteSelect
              disableClearable
              error={!!errors[FORM_FIELDS_MAP.Status.key]}
              errorText={errors[FORM_FIELDS_MAP.Status.key]?.message}
              getOptionSelected={idOptionSelected}
              name={FORM_FIELDS_MAP.Status.key}
              placeholder={strings.shared.fields.status}
              renderOption={statusRenderOption}
              startAdornment={
                currentStatus &&
                statusStartAdornment(
                  currentStatus?.style_class_name || currentStatus?.style || currentStatus?.color
                )
              }
              url={statusOptionsUrl}
            />
          }
          onChange={handleStatusChange}
          onChangeName="onSelect"
          valueName="selectedValue"
        />
      </Grid>
      <Controller
        name={FORM_FIELDS_MAP.DeclinationDetails.key}
        control={control}
        defaultValue={null}
        as={HiddenField}
      />
    </Grid>
  );
};
